<template>
    <section class="image-preview">
        <div class="image-preview__images">

            <!-- Top image -->
            <div
                v-if="Boolean(categorizedProducts[activeTab].top.length)"
                :class="['image-preview__image', 'image-preview__image--top', { 'image-preview__image--default': product.top.isDefaultState }]"
            >
            <span v-if="product.top.isDefaultState" class='image-preview__image-border-left'></span>
            <span v-if="product.top.isDefaultState" class='image-preview__image-border-right'></span>
                <ImageField
                    class="image-preview__image-field image-preview__image-field--top"
                    :obj="{ 'url': product.top.src, 'alt': product.top.alt, 'width': '870', 'height': '1077' }"
                    :isLoadingLazy="true"
                    :key="product.top.src"
                />
                <p v-if="product.top.isDefaultState" class="image-preview__image-select-msg">{{ topImagePlaceholder }}</p>
            </div>

            <!-- Bottom image -->
            <div
                v-if="Boolean(categorizedProducts[activeTab].bottom.length)"
                :class="['image-preview__image', 'image-preview__image--bottom', { 'image-preview__image--default': product.bottom.isDefaultState }]"
            >
            <span v-if="product.bottom.isDefaultState" class='image-preview__image-border-left'></span>
            <span v-if="product.bottom.isDefaultState" class='image-preview__image-border-right'></span>
                <ImageField
                    class="image-preview__image-field image-preview__image-field--bottom"
                    :obj="{ 'url': product.bottom.src, 'alt': product.bottom.alt, 'width': '870', 'height': '1077' }"
                    :isLoadingLazy="true"
                    :key="product.bottom.src"
                />
                <p v-if="product.bottom.isDefaultState" class="image-preview__image-select-msg">{{ bottomImagePlaceholder }}</p>
            </div>

            <ViewSelectionsCTA v-if="onViewSelectionsClick" :onViewSelectionsClick="onViewSelectionsClick" />
        </div>
    </section>
</template>


<script setup>
import { computed, reactive, toRefs } from 'vue';
import ImageField from '../../global/image.vue';
import ViewSelectionsCTA from './view-selections-cta.vue';
import { useStore } from 'vuex';

const props = defineProps({
    activeTab: {
        type: String,
        default: ''
    },
    onViewSelectionsClick: {
        type: Function
    },
    categorizedProducts: {
        type: Array,
        default: []
    },
    topImagePlaceholder: {
        type: String,
        default: ''
    },
    bottomImagePlaceholder: {
        type: String,
        default: ''
    }
});

const store = useStore();
const { activeTab } = toRefs(props);
const selectedProductsFromContext = reactive(store.state.byk.selectedProducts);

const product = computed(() => {
    const { top, bottom } = selectedProductsFromContext?.[activeTab.value] || {};

    const getImageData = (position, defaultSrc, defaultAlt) => {
        const selectedVariant = position?.[0]?.selectedVariantDetails?.selectedFeatureImage;
        return {
            src: selectedVariant?.src || defaultSrc,
            alt: selectedVariant?.src ? position?.[0]?.title : defaultAlt,
            isDefaultState: !Boolean(selectedVariant?.src)
        };
    };

    return {
        top: getImageData(top, 'https://stio.cdn.prismic.io/stio/ZtG3GUaF0TcGJlas_Shirt_Desktop.svg', 'Default Top Image'),
        bottom: getImageData(bottom, 'https://stio.cdn.prismic.io/stio/ZtG3F0aF0TcGJlap_Pant_Desktop.svg', 'Default Bottom Image')
    };
});

</script>
